import { resetDataQuery } from '@/services/analytics/Action';
import { useDispatch } from 'react-redux';

export const useResetDataQuery = () => {
  const dispatch = useDispatch();
  const reset = () => dispatch(resetDataQuery());
  return [reset];
};
